import AppCrashReports from '@/components/Templates/AppCrashReport/AppCrashReports/AppCrashReports';

const AppCrashReportsPage = () => {
	return <AppCrashReports />;
};

export default AppCrashReportsPage;
